import { useSurvey } from '../hooks/useSurvey';
import { consentItems } from '@/mocks/surveyData';

interface NavigationButtonsProps {
  survey: ReturnType<typeof useSurvey>;
}

export default function NavigationButtons({ survey }: NavigationButtonsProps) {
  const { currentStep, isSubmitting, goNext, goPrev, submit, answers, submitError } = survey;

  if (currentStep === 0) {
    return (
      <div className="px-6">
        <button
          type="button"
          onClick={goNext}
          className="w-full py-3.5 rounded-xl bg-coral text-white text-base font-semibold min-h-[48px] cursor-pointer hover:bg-coral-dark active:bg-coral-dark transition-colors duration-200 whitespace-nowrap"
        >
          시작하기
        </button>
      </div>
    );
  }

  if (currentStep === 16) {
    return (
      <div className="px-6">
        <button
          type="button"
          onClick={() => {
            // placeholder for reservation check
          }}
          className="w-full py-3.5 rounded-xl bg-coral text-white text-base font-semibold min-h-[48px] cursor-pointer hover:bg-coral-dark active:bg-coral-dark transition-colors duration-200 whitespace-nowrap"
        >
          내 예약 확인하기
        </button>
      </div>
    );
  }

  if (currentStep === 15) {
    const requiredChecked = consentItems
      .filter((item) => item.required)
      .every((item) => answers[item.id] === true);

    return (
      <div className="px-6 flex gap-3">
        <button
          type="button"
          onClick={goPrev}
          disabled={isSubmitting}
          className="flex-1 py-3.5 rounded-xl border-2 border-border-color bg-white text-text-primary text-sm font-semibold min-h-[48px] cursor-pointer hover:bg-border-color/30 active:bg-border-color/50 transition-colors duration-200 whitespace-nowrap disabled:opacity-40 disabled:cursor-not-allowed"
        >
          이전
        </button>
        <button
          type="button"
          onClick={submit}
          disabled={!requiredChecked || isSubmitting}
          className="flex-1 py-3.5 rounded-xl bg-coral text-white text-sm font-semibold min-h-[48px] cursor-pointer hover:bg-coral-dark active:bg-coral-dark transition-colors duration-200 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? (
            <span className="flex items-center justify-center gap-1.5">
              <i className="ri-loader-4-line animate-spin" />
              제출 중…
            </span>
          ) : (
            submitError ? '다시 제출' : '동의하고 제출'
          )}
        </button>
      </div>
    );
  }

  return (
    <div className="px-6 flex gap-3">
      <button
        type="button"
        onClick={goPrev}
        className="flex-1 py-3.5 rounded-xl border-2 border-border-color bg-white text-text-primary text-sm font-semibold min-h-[48px] cursor-pointer hover:bg-border-color/30 active:bg-border-color/50 transition-colors duration-200 whitespace-nowrap"
      >
        이전
      </button>
      <button
        type="button"
        onClick={goNext}
        className="flex-1 py-3.5 rounded-xl bg-coral text-white text-sm font-semibold min-h-[48px] cursor-pointer hover:bg-coral-dark active:bg-coral-dark transition-colors duration-200 whitespace-nowrap"
      >
        다음
      </button>
    </div>
  );
}